const config = require('../../config/config');

const servicesSettings = config.services;
const basePath = `${servicesSettings.MG_PROTOCOL}://${servicesSettings.MG_DOMAIN}:${servicesSettings.MG_PORT}${servicesSettings.MG_SERVICES_BASE}`;

/**
 * Throw response if invalid status code
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  throw response;
}

/**
 * Transform response to json
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
function parseJSON(response) {
  return response.json();
}

module.exports = {
  checkDealer(name) {
    return fetch(`${basePath}dealerCheck/${encodeURIComponent(name)}`)
      .then(checkStatus)
      .then(parseJSON);
  }
};
